import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web.drivingzone-training/web.drivingzone-training/src/app/support/contact/[slug]/client.tsx");
